import {useRootStore} from '@/store'
import {selectGlobalTranslateStore} from '@/store/selectors'
import React, {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {useMe} from '@/features/authentication/queries/useMe.ts'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {getCorrectUserId} from '@/utilities/helpers'
import {UserRoleE} from '@/types'
import {useGetRepresentedUser} from '@/hooks/useGetRepresentedHost'
import {LocalStorageManager} from '@/utilities/localStorage'
import useSSEConnection from '@/integrations/SSE/hooks/useSSEConection'
import {useSSE} from '@/integrations/SSE/hooks/useSSE'
import {SSEEventType} from '@/integrations/SSE/types'
import {SSEProvider} from '@/integrations/SSE/SSEProvider'
import {UserV3} from '@/features/authentication/types'
import {useGetNotificationsHistory} from '@/features/notifications/queries/useGetNotificationsHistory'

// here the user always exists, otherwise I should be in a PublicRoute
export const PrivateDataLayer: React.FC = () => {
    const {data: user, loggedIn, isLoading: isLoadingUser} = useMe()
    const isRepresentative = user?.type === UserRoleE.Representative
    const isAgent = user?.type === UserRoleE.Agent

    const {representedUser, agentAndRepsHosts, isLoading} = useGetRepresentedUser(Boolean(loggedIn))
    const correctUser = isRepresentative || isAgent ? representedUser : user

    const {eventSource} = useSSEConnection(correctUser as UserV3, loggedIn, isRepresentative)

    useSSE({eventSource, eventType: SSEEventType.CHAT, user: user as UserV3})
    useSSE({eventSource, eventType: SSEEventType.NOTIFICATION, user: user as UserV3})
    useSSE({eventSource, eventType: SSEEventType.GOAL_DONATE, user: user as UserV3})
    useSSE({eventSource, eventType: SSEEventType.PAID_CONNECTION_MESSAGE, user: user as UserV3})

    const {initialTranslateConfig} = useRootStore(selectGlobalTranslateStore)
    const correctUserId = user ? getCorrectUserId(user) : undefined

    // Here we initialize the chat channels from API server
    useGetNotificationsHistory({})

    useEffect(() => {
        if (!LocalStorageManager.chatUserId.get() && agentAndRepsHosts && agentAndRepsHosts?.length) {
            LocalStorageManager.chatUserId.set(agentAndRepsHosts[0]?.rookieId)
        }
    }, [agentAndRepsHosts])

    useEffect(() => {
        !!correctUserId &&
            initialTranslateConfig({
                userID: String(correctUserId)
            })
    }, [correctUserId])

    if (isLoadingUser || isLoading) return <Spinner />
    if ((isAgent || isRepresentative) && !agentAndRepsHosts?.length) return <Outlet />
    return loggedIn ? (
        <SSEProvider eventSource={eventSource}>
            <Outlet />
        </SSEProvider>
    ) : (
        <Outlet />
    )
}
